import {
  GetDevelopmentAreaResponse,
  UpdateDevelopmentAreaBody,
} from "../../../types/api/developmentArea.type";
import httpClient from "../../client/HttpClient";

const DevelopmentAreaService = {
  async get(): Promise<GetDevelopmentAreaResponse> {
    const response = await httpClient.get<GetDevelopmentAreaResponse>(
      "v1/development-area",
    );
    return response;
  },
  async update(body: UpdateDevelopmentAreaBody): Promise<void> {
    await httpClient.put("v1/development-area", body);
  },
};

export default DevelopmentAreaService;
